export default __webpack_public_path__ + "static/media/screenshot.6029bf27.png";